import React, { useState } from "react";
import { Input, Select, Button, DatePicker, Spin, Flex } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";
import moment from "moment";

const { Option } = Select;

const SearchFilters = ({
  onSearch,
  assignees,
  managers,
  statusOptions,
  filtersList,
  isFiltersDataFetched,
  onCancel,
  authorsList,
  sourcesList,
}) => {

  const { MonthPicker, RangePicker } = DatePicker; // Import MonthPicker
  const isMobile = useIsMobile();
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    phone_no: "",
    assignee: "",
    manager: "",
    status: "",
    next_activity: null,
    author: "",
    source: "",
    created: "",
    assigned_on: "",
    assignee_assigned_on: "",
    manager_assigned_on: "",
    month: "",
    // activity_date: "",
    activity_start_date: "",
    activity_end_date: "",
  });

  // const handleSearch = () => {
  //   const formattedNextActivity = filters.next_activity
  //     ? dayjs(filters.next_activity).format("M/D/YYYY") // Formats as MM/DD/YYYY
  //     : null;

  //   const formattedActiveTill = filters.active_till
  //     ? dayjs(filters.active_till).format("M/D/YYYY") // Formats as MM/DD/YYYY
  //     : null;

  //   onSearch({
  //     ...filters,
  //     next_activity: formattedNextActivity,
  //     active_till: formattedActiveTill,
  //   });
  // };
  const handleSearch = () => {
    const formattedNextActivity = filters.next_activity
      ? dayjs(filters.next_activity).format("YYYY-MM-DD") // Formats as ISO string
      : null;

    const formattedCreated = filters.created
      ? dayjs(filters.created).format("YYYY-MM-DD") // Formats as ISO string
      : null;

    // const formattedActivityDate = filters.activity_date
    //   ? dayjs(filters.activity_date).format("YYYY-MM-DD") // Formats as ISO string
    //   : null;

    const formattedActiveTill = filters.active_till
      ? dayjs(filters.active_till).format("YYYY-MM-DD") // Formats as ISO string
      : null;
    const formattedAssignedOn = filters.assigned_on
      ? dayjs(filters.assigned_on).format("YYYY-MM-DD") // Formats as ISO string
      : null;
    const formattedAssgineeAssignedOn = filters.assignee_assigned_on
      ? dayjs(filters.assignee_assigned_on).format("YYYY-MM-DD") // Formats as ISO string
      : null;
    const formattedManagerAssignedOn = filters.manager_assigned_on
      ? dayjs(filters.manager_assigned_on).format("YYYY-MM-DD") // Formats as ISO string
      : null;
    const formattedMonth = filters.month
      ? dayjs(filters.month).format("YYYY-MM") // Format month as "YYYY-MM"
      : null;

      const formattedActivityStartDate = filters.activity_start_date
      ? dayjs(filters.activity_start_date).format("YYYY-MM-DD")
      : null;

      const formattedActivityEndDate = filters.activity_end_date
        ? dayjs(filters.activity_end_date).format("YYYY-MM-DD")
        : null;

    onSearch({
      ...filters,
      next_activity: formattedNextActivity,
      created: formattedCreated,
      active_till: formattedActiveTill,
      assigned_on: formattedAssignedOn,
      assignee_assigned_on: formattedAssgineeAssignedOn,
      manager_assigned_on: formattedManagerAssignedOn,
      month: formattedMonth, // Add formatted month to the search
      // activity_date: formattedActivityDate,
      activity_start_date: formattedActivityStartDate,
      activity_end_date: formattedActivityEndDate,

    });
  };

  const handleCancelSearch = async () => {
    setFilters({
      name: "",
      email: "",
      phone_no: "",
      assignee: "",
      manager: "",
      status: "",
      next_activity: null,
      author: "",
      source: "",
      created: "",
      assigned_on: "",
      month: "",
      // activity_date: "",
      activity_start_date: "",
      activity_end_date: "",
    });
    await onCancel();
  };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const formatOptions = (list) =>
    list.map(({ uid, name }) => ({
      value: uid,
      label: name,
    }));

  const renderFilter = (filter) => {
    switch (filter) {
      case "name":
        return (
          <Input
            placeholder="Filter by Name"
            style={{ width: isMobile ? "80vw" : 300 }}
            value={filters.name}
            onChange={(e) => handleFilterChange("name", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "email":
        return (
          <Input
            placeholder="Filter by Email"
            style={{ width: isMobile ? "80vw" : 300 }}
            value={filters.email}
            onChange={(e) => handleFilterChange("email", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "phone_no":
        return (
          <Input
            placeholder="Filter by Phone"
            style={{ width: isMobile ? "80vw" : 300 }}
            value={filters.phone_no}
            onChange={(e) => handleFilterChange("phone_no", e.target.value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "assignee":
        return (
          <Select
            mode="multiple" // Enables multi-select
            showSearch
            placeholder="Filter by Assignee"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.assignee || []} // Multi-select requires an array for the value
            onChange={(value) => handleFilterChange("assignee", value)}
            onKeyDown={handleKeyDown}
            options={formatOptions(assignees)}
            optionFilterProp="children"
            allowClear
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        );

      case "manager":
        return (
          <Select
            mode="multiple" // Enables multi-select
            showSearch
            placeholder="Filter by Manager"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.manager || []} // Multi-select requires an array for the value
            onChange={(value) => handleFilterChange("manager", value)}
            onKeyDown={handleKeyDown}
            options={formatOptions(managers)}
            allowClear
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        );

      case "status":
        return (
          <Select
            placeholder="Select Status"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.status || undefined}
            onChange={(value) => handleFilterChange("status", value)}
            onKeyDown={handleKeyDown}
            allowClear>
            {statusOptions.map(({ value, label }) => (
              <Option key={value} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        );
      case "next_activity":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Next Activity"
            value={filters.next_activity}
            onChange={(value) => handleFilterChange("next_activity", value)}
            onKeyDown={handleKeyDown}
          />
        );
      // case "activity_date":
      //   return (
      //     <DatePicker
      //       style={{ width: isMobile ? "80vw" : 300 }}
      //       placeholder="Filter by Activity Date"
      //       value={filters.activity_date}
      //       onChange={(value) => handleFilterChange("activity_date", value)}
      //     />
      //   );
      case "activity_start_date":
        return (
          <RangePicker
          style={{ width: isMobile ? "80vw" : 300 }}
          placeholder={["Activity Start Date", "Activity End Date"]}
          value={[
            filters.activity_start_date,
            filters.activity_end_date,
          ]}
          onChange={(dates) => {
            handleFilterChange("activity_start_date", dates ? dates[0] : null);
            handleFilterChange("activity_end_date", dates ? dates[1] : null);
          }}
          onKeyDown={handleKeyDown}
        />
        );
      case "created":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Created Date"
            value={filters.created}
            onChange={(value) => handleFilterChange("created", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "month":
        return (
          <MonthPicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Month"
            value={filters.month ? dayjs(filters.month) : null}
            onChange={(value) => handleFilterChange("month", value)}
            onKeyDown={handleKeyDown}
            format="YYYY-MM"
          />
        );

      case "author":
        return (
          <Select
            placeholder="Filter by Author"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.author || undefined}
            onChange={(value) => handleFilterChange("author", value)}
            onKeyDown={handleKeyDown}
            options={
              Array.isArray(authorsList)
                ? authorsList.map((author) => ({
                    value: author.uid, // Use the `uid` as the value
                    label: author.full_name, // Use the `full_name` as the display label
                  }))
                : []
            } // Fallback to an empty array if authorsList is not an array
            allowClear
          />
        );

      case "source":
        return (
          <Select
            placeholder="Filter by Source"
            style={{ width: isMobile ? "80vw" : 300, textAlign: "left" }}
            value={filters.source || undefined}
            onChange={(value) => handleFilterChange("source", value)}
            onKeyDown={handleKeyDown}
            options={sourcesList?.data?.map((source) => ({
              value: source.key, // Assuming you want to use 'key' as the value
              label: source.label, // Assuming you want to use 'label' as the display text
            }))}
            allowClear
          />
        );

      case "active_till":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Active Till"
            value={filters.active_till}
            onChange={(value) => handleFilterChange("active_till", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "assigned_on":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Assigned On"
            value={filters.assigned_on}
            onChange={(value) => handleFilterChange("assigned_on", value)}
            onKeyDown={handleKeyDown}
          />
        );
      case "assignee_assigned_on":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Assignee assigned on"
            value={filters.assignee_assigned_on}
            onChange={(value) =>
              handleFilterChange("assignee_assigned_on", value)
            }
            onKeyDown={handleKeyDown}
          />
        );
      case "manager_assigned_on":
        return (
          <DatePicker
            style={{ width: isMobile ? "80vw" : 300 }}
            placeholder="Filter by Manager assigned on"
            value={filters.manager_assigned_on}
            onChange={(value) =>
              handleFilterChange("manager_assigned_on", value)
            }
            onKeyDown={handleKeyDown}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        width: "100%",
        background: "#eceff1",
        padding: "20px 20px",
        borderRadius: "8px",
        margin: "15px 0px",
      }}>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}>
        {isFiltersDataFetched ? (
          <Flex style={{ width: "100%" }} justify="center" align="center">
            <Spin />
          </Flex>
        ) : (
          filtersList.map((filter) => renderFilter(filter))
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 20 }}>
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={handleSearch}
          style={{ width: 140, background: "#040724" }}>
          Search
        </Button>
        <Button style={{ width: 140 }} onClick={handleCancelSearch}>
          Reset
        </Button>
      </div>
    </div>
  );
};

export default SearchFilters;
